module.exports = __webpack_public_path__ + "dbb435daf7d98cad7c8ebcbf1d302369.png";